import { Injectable }    from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable }    from 'rxjs/Observable';

export interface CanComponentDeactivate {
 canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate) {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}


// WEBPACK FOOTER //
// /Users/jackwoodward/Desktop/JCW Services/Huckleberry Partners/Hoxby Internal Projects/intranet/hoxbyHub/src/app/can-deactivate-guard.service.ts